"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = cookieFactory; // documentation of setting and getting cookies can be found here
// https://www.w3schools.com/Js/js_cookies.asp

/**
 *
 * @param {string} cookieName
 *  A cookie factory function that creates and deletes the cookies,
 * and also retrives the value from the cookie
 */

function cookieFactory(cookieName) {
  /**
   * @param {string} cookieValue  value of the cookie
   * @param {number} exdays       expiry time in days
   */
  function createCookie(cookieValue, exdays) {
    // get the present date
    var d = new Date(); //set the expiry date converting the given day from argument in ms

    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString(); //set the cookie with the given values

    if (typeof window !== 'undefined') {
      document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/';
    }
  }
  /**
   *  retrive the value from the cookie
   */


  function getCookie() {
    // Take the cookiename as parameter (cname).
    // Create a variable (name) with the text to search for (cname + "=").
    var name = cookieName + '='; // Decode the cookie string, to handle cookies with special characters, e.g. '$'
    // Split document.cookie on semicolons into an array called c.

    if (typeof window !== 'undefined') {
      var ca = document.cookie.split(';'); // Loop through the ca array (i = 0; i < ca.length; i++)
      //check necessary for server side rendering

      for (var i = 0; i < ca.length; i++) {
        // read out each value c = ca[i]).
        var c = ca[i]; // eslint-disable-next-line

        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        } // eslint-disable-next-line


        var isCookieFound = c.indexOf(name) === 0;
        if (isCookieFound) return c.substring(name.length, c.length);
      }
    }
  }
  /**
   * deletes the cookie by setting the time of cookie to past.
   */


  function deleteCookie() {
    var d = new Date();
    d.setTime(d.getTime() - 1000 * 60 * 60 * 24);
    var expires = "expires=".concat(d.toGMTString());

    if (typeof document !== 'undefined') {
      document.cookie = "".concat(cookieName, "=; ").concat(expires, ";");
    }
  }

  return {
    createCookie: createCookie,
    getCookie: getCookie,
    deleteCookie: deleteCookie
  };
}